import Auth from '../modules/Authentication'
import { apiUrl } from '../variables/index'
import { handleErrors, handleResponse } from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
export default class Corporate {
  constructor() {
    this.auth = new Auth()
  }

  dropdown = () => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}corporates/`, { headers }).then(handleErrors).then(handleResponse)
  }
  getByOwner = (ownerKey) => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}corporates/owner/${ownerKey}`, { headers }).then(handleErrors).then(handleResponse)
  }
}
